import script from "./goRinSyo0048.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0048.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0048.vue?vue&type=style&index=0&id=0c1e5310&lang=scss"

const __exports__ = script;

export default __exports__